import { ItiBaseDto } from '@/iti-core-vue';
import { FieldType } from './field-type';
import { UnitType } from './unit-type';

export class Field extends ItiBaseDto {
    public code!: string;
    public label!: string;
    public description!: string;
    //public fieldTypeId!: number;
    public fieldTypeCode!: string;
    public fieldTypeType!: string;
    //public unitTypeId!: number;
    public unitTypeCode!: string;
    public unitTypeDescription!: string;
    public defaultValue!: string;
    public obligatory!: boolean;
    public multipleSelector!: boolean;    
    public help!: string;
    public validationRules!: string;
    public errorMessage!: string;
    public readOnly!: boolean;
    //public templateId!: number;
    public fieldType!: FieldType;
    public unitType!: UnitType;

}